'use strict';

/**
 * @returns {boolean} true when the shopper is logged in
 */
function isLoggedIn() {
    return $('#customer-authenticated').val() === 'true' || $('.isLoggedInUser').first().val() === 'true';
}

/**
 * Opens the site login popup; after login the server continues to the join form of the target.
 * @param {Object|boolean} target { scheme, type, passbookNo }, or true to use the join form
 *  the server remembered when the shopper opened it while logged out
 * @param {string} [fallbackUrl] join form URL used when the login popup is not on the page
 */
function loginAndContinue(target, fallbackUrl) {
    if ($('#loginPopupModal').length) {
        window.redirectToJoinScheme = target || true;
        $('#loginPopupModal').modal('show');
    } else if (fallbackUrl) {
        window.location.href = fallbackUrl;
    } else {
        window.location.reload();
    }
}

/**
 * Navigates to Error-Start when the server denied access to a scheme.
 * @param {Object} data JSON response, or a jqXHR whose responseJSON is checked
 * @returns {boolean} true when the page is being redirected
 */
function handleAccessDenied(data) {
    var response = data && data.responseJSON ? data.responseJSON : data;
    if (response && typeof response === 'object' && response.redirectUrl && response.success === false) {
        window.location.href = response.redirectUrl;
        return true;
    }
    return false;
}

/**
 * A logged out AJAX call is redirected to the home page, so it returns HTML instead of JSON.
 * @param {*} response AJAX response
 * @returns {boolean} true when the session is no longer logged in
 */
function isLoggedOutResponse(response) {
    return typeof response === 'string';
}

module.exports = {
    isLoggedIn: isLoggedIn,
    loginAndContinue: loginAndContinue,
    handleAccessDenied: handleAccessDenied,
    isLoggedOutResponse: isLoggedOutResponse
};
